export default "__VITE_ASSET__VTGGMitI__"